export const PP_ACCEPTED = '1';
export const EXCLUSIVITY = '32';
